import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';

type Props = {
    title: string;
    finalAmountFormatted?: string;
    isFetching: boolean;
};

const StySectionTitle = styled(Typography, {
    name: 'StySectionTitle',
})(({ theme }) => ({
    paddingLeft: '16px',
    color: theme.palette.primary.main,
}));

export default function BudgetBalanceTableHeader({
    title = '',
    finalAmountFormatted = undefined,
    isFetching,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const translatedTitle = t(title);
    return (
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-cadrage"
        >
            <StySectionTitle
                variant="body1Bold"
                sx={{ display: 'inline-block' }}
            >
                {translatedTitle}
                {isFetching ? (
                    <Skeleton
                        variant="text"
                        sx={{ display: 'inline-block', width: '10ch', ml: 2 }}
                    />
                ) : (
                    ` : ${finalAmountFormatted}`
                )}
            </StySectionTitle>
        </AccordionSummary>
    );
}
